var _defs, _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "email",
    width: 33,
    height: 22,
    viewBox: "0 0 33 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-313{fill:#BCE3C0}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1869",
    fill: "#A9DBAF",
    d: "M43.779 254.986a3.437 3.437 0 0 1-2.64 1.237H15.014a3.437 3.437 0 0 1-2.64-1.237l12.609-10.5 1.306.894a3.147 3.147 0 0 0 3.575 0l1.306-.894z",
    transform: "translate(-11.576 -234.223)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_1870",
    fill: "#DBEFDF",
    d: "M41.178 86.832l-12.8 8.759-1.306.894a3.147 3.147 0 0 1-3.575 0l-1.306-.894-12.8-8.773a3.452 3.452 0 0 1 2.833-1.485h26.121a3.392 3.392 0 0 1 2.833 1.499z",
    transform: "translate(-8.783 -85.333)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_113",
    transform: "translate(0 1.485)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1871",
    d: "M13.406 117.147L.8 127.652a3.422 3.422 0 0 1-.8-2.2v-15.125a3.388 3.388 0 0 1 .605-1.952z",
    className: "cls-313",
    transform: "translate(0 -108.375)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1872",
    d: "M317.407 110.527v15.125a3.422 3.422 0 0 1-.8 2.2L304 117.347l12.8-8.759a3.376 3.376 0 0 1 .607 1.939z",
    className: "cls-313",
    transform: "translate(-284.407 -108.574)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.921711a3705d4a814e9e40001922d1bd.svg";
export { ForwardRef as ReactComponent };